var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLowerFace = function SvgLowerFace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.722c-.779-1.309-2.856-1.309-3.635 0-.579.973-2.596 2.393-3.115 2.623.866 1.222 3.894 3.665 6.75 3.665 3.375 0 5.798-2.443 6.75-3.665-.52-.23-1.643-1.102-2.856-2.623C11.856 5.42 9.78 5.42 9 6.722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 9.375c1.968.392 7.423.94 13.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.192 8.158c.672.648 1.233 1.044 1.558 1.187a11 11 0 0 1-2.2 2.107M4.378 7.817c-.801.714-1.787 1.377-2.128 1.528.489.69 1.667 1.77 3.115 2.578"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLowerFace);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;